import React from 'react';

const Mintag = ({label}) => {
    return (
        <div className='min-tag fl fs10'>
          {label}  
        </div>
    );
};

export default Mintag;